export default "__VITE_ASSET__CvGi4WPe__"